<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="BODY CARE" src="assets/img/ph_lesson08.jpg"><span>BODY CARE</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson09.png">
                <p>毎日休みなく働いているあなたの身体をいたわるためのプログラムです。ストレッチやセルフマッサージなどを取り入れて、ご自身の身体をセルフケアしていきましょう。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="MINDFULNESS YOGA" src="assets/img/ph_lesson10.jpg"><span>MINDFULNESS<br>YOGA</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson11.png">
                <p>マインドフルネスでは身体と心をつなげることを大切にします。このプログラムではゆったりと身体を味わいながら動き、その時の心の変化も気づいていきます。シンプルな動きですのでどなたにも楽しんでいただきます。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="YIN YOGA" src="assets/img/ph_lesson11.jpg"><span>YIN YOGA</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson12.png">
                <p>深い呼吸とポージングで心と身体を深部からゆるめるヨガです。ひとつのポーズに時間をかけて行い、内臓にも刺激を与えていきます。ご自身の心と身体への理解が深まります。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="SLEEP" src="assets/img/ph_lesson05.jpg"><span>SLEEP</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson06.png">
                <p>寝つきが悪かったり、眠りが浅い方のために、睡眠の質を高めるためのプログラムです。ボディスキャンなどの方法で身体からのメッセージに耳を傾け、深いリラクゼーションに導きます。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'

export default {
  name: 'Recommend05',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
